export const BOOK_LABELS = {
  gr8: 'GR8',
  betconstruct: 'BetConstruct'
};

export const PROVIDER_LABELS = {
  pragmatic: 'Pragmatic Play',
  playson: 'Playson',
  databetrix: 'Databetrix',
  evolution: 'Evolution',
  'evo-live': 'Evolution Live',
  'evo-evolution': 'Evolution',
  'evo-netent': 'NetEnt',
  'evo-redtiger': 'Red Tiger',
  'bbgame-evoa': 'Evolution (EVOA)',
  pgsoft: 'PG Soft',
  hacksaw: 'Hacksaw',
  popok: 'PopOK Gaming',
  'pascal-gaming': 'Pascal Gaming',
  pateplay: 'PatePlay',
  creedroomz: 'CreedRoomz',
  'digitain-galaxsys': 'Digitain/Galaxsys',
  worldmatch: 'WorldMatch',
  booming: 'Booming Games',
  mascot: 'Mascot Gaming',
  fazi: 'Fazi',
  amusnet: 'Amusnet',
  inout: 'InOut Games',
  bgaming: 'BGaming',
  belatragames: 'Belatra Games',
  '3oaks': '3 Oaks Gaming',
  unknown: 'Unknown'
};

export const providerLabel = (id) => {
  if (!id) return 'Unknown';
  return PROVIDER_LABELS[id] || id.charAt(0).toUpperCase() + id.slice(1);
};

export const bookLabel = (id) => BOOK_LABELS[id] || id;

// Databetrix callbacks identify a game only by a 40-char catalog hash and name
// the studio behind it as the provider, so these ids only arrive through it.
const DATABETRIX_GAME_ID = /^[0-9a-f]{40}$/;
const DATABETRIX_PROVIDERS = new Set(['databetrix', 'evolution', 'bbgame-evoa']);

export const isDatabetrixGameId = (gameId) => DATABETRIX_GAME_ID.test(String(gameId || ''));
export const isDatabetrixProvider = (id) => DATABETRIX_PROVIDERS.has(id);
